export default function WhatIncluded() {
  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            年度管理方案包含哪些基本內容？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-server-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">網站代管與基本維運</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  確保網站持續上線，處理基本的主機與技術維護工作
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">上線狀態與基本穩定度維持</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  監控網站運作狀況，及時處理異常與基本問題
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-edit-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">內容小幅調整</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  協助處理文字、圖片等基本內容更新（非重新設計）
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-mail-send-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">聯絡功能與基本互動正常運作</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  確保表單、聯絡方式等互動功能可正常使用
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:shadow-md transition-shadow md:col-span-2">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-customer-service-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">有明確窗口可處理網站相關事項</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  提供固定聯繫窗口，讓您有需求時知道該找誰處理
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
